import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    data() {
        return {
            modalRecebimentosLoteVisible: false,
            modalVinculoManualRecebimentosVisible: false,
            modalSucessoProcessamentoLoteVisible: false,
            modalContratosEnLoteVisible: false,
            carregandoUploadRecebimentos: false,
            carregandoConfirmacaoVinculos: false,
            carregandoConfirmacaoContratos: false,
            carregandoConfirmacaoEnLote: false,
            recebimentosPendentesVinculo: [],
            territoriosDisponiveisVinculo: [],
            vinculosAutomaticosRecebimentos: [],
            dadosLoteRecebimentos: null,
            contratosSucessoProcessamento: [],
            contratosEnLote: []
        };
    },

    computed: {
        statusRecebimentosCodigo() {
            return this.dadosLoteRecebimentos &&
                this.dadosLoteRecebimentos.statusCodigo
                ? this.dadosLoteRecebimentos.statusCodigo
                : '';
        },

        recebimentosEmProcessamento() {
            return ['EM_PROCESSAMENTO', 'PROCESSANDO'].includes(
                this.statusRecebimentosCodigo
            );
        },

        recebimentosAguardandoVinculo() {
            return this.statusRecebimentosCodigo === 'AGUARDANDO_VINCULO';
        },

        statusRecebimentosTagType() {
            if (
                ['CONCLUIDO', 'PROCESSADO'].includes(
                    this.statusRecebimentosCodigo
                )
            ) {
                return 'success';
            }

            if (
                ['ERRO_PROCESSAR', 'ERRO_AO_PROCESSAR'].includes(
                    this.statusRecebimentosCodigo
                )
            ) {
                return 'danger';
            }

            if (this.recebimentosEmProcessamento) {
                return 'info';
            }

            if (this.recebimentosAguardandoVinculo) {
                return 'warning';
            }

            return 'warning';
        },

        statusRecebimentosTexto() {
            if (this.dadosLoteRecebimentos && this.dadosLoteRecebimentos.status) {
                return this.dadosLoteRecebimentos.status;
            }

            if (
                ['CONCLUIDO', 'PROCESSADO'].includes(
                    this.statusRecebimentosCodigo
                )
            ) {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusConcluido'
                );
            }

            if (
                ['ERRO_PROCESSAR', 'ERRO_AO_PROCESSAR'].includes(
                    this.statusRecebimentosCodigo
                )
            ) {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusErroProcessar'
                );
            }

            if (this.recebimentosEmProcessamento) {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusProcessamento'
                );
            }

            return this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusAguardando'
            );
        }
    },

    methods: {
        abrirModalRecebimentosLote() {
            this.modalRecebimentosLoteVisible = true;
        },

        fecharModalRecebimentosLote() {
            this.modalRecebimentosLoteVisible = false;
        },

        fecharModalVinculoManualRecebimentos() {
            this.modalVinculoManualRecebimentosVisible = false;
        },

        async enviarRecebimentosLote(planilha) {
            this.carregandoUploadRecebimentos = true;
            this.dadosLoteRecebimentos = {
                nomeArquivo: planilha.name,
                statusCodigo: 'EM_PROCESSAMENTO'
            };
            this.fecharModalRecebimentosLote();
            this.notificarProcessamentoRecebimentosLoteIniciado();

            await this._conectarWebSocketRecebimentos();

            try {
                const { data } = await ContratoOriginacaoServiceSubEmpresa.uploadRecebimentosLote(planilha);
                this.dadosLoteRecebimentos = data;

                if (data.statusCodigo === 'AGUARDANDO_VINCULO') {
                    disconnect();
                    await this.abrirVinculoManualParaLote(data.id);
                }
            } catch {
                this.dadosLoteRecebimentos = {
                    nomeArquivo: planilha.name,
                    statusCodigo: 'ERRO_AO_PROCESSAR'
                };
                disconnect();
            } finally {
                this.carregandoUploadRecebimentos = false;
                this.notificarStatusRecebimentosLote();
            }
        },

        async _conectarWebSocketRecebimentos() {
            try {
                const idUsuario = this.$store.getters.usuarioLogado?.idKeyCloack;
                if (!idUsuario) return;
                await connect();
                subscribe(`${idUsuario}/lote/recebimentos-ar`, this.handleWebSocketRecebimentosLote);
            } catch {
                // WS failure is non-fatal; modal can still be opened manually
            }
        },

        async abrirVinculoManualParaLote(idLote) {
            try {
                const [pendentesRes, territoriosRes] = await Promise.all([
                    ContratoOriginacaoServiceSubEmpresa.buscarPendentesVinculoRecebimentos(idLote),
                    ContratoOriginacaoServiceSubEmpresa.buscarTerritorioFiltroAR('')
                ]);
                this.recebimentosPendentesVinculo = pendentesRes.data;
                this.territoriosDisponiveisVinculo = territoriosRes.data;
                this.modalVinculoManualRecebimentosVisible = true;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.erroBuscarPendentes'
                    ),
                    position: 'top-right'
                });
            }
        },

        async buscarTerritoriosVinculoAR(filtro) {
            try {
                const { data } = await ContratoOriginacaoServiceSubEmpresa.buscarTerritorioFiltroAR(filtro || '');
                this.territoriosDisponiveisVinculo = data;
            } catch {
                this.territoriosDisponiveisVinculo = [];
            }
        },

        async confirmarVinculosRecebimentos(vinculosManuais) {
            this.carregandoConfirmacaoVinculos = true;

            try {
                const idLote = this.dadosLoteRecebimentos && this.dadosLoteRecebimentos.id;
                if (!idLote) throw new Error('ID do lote não encontrado.');

                const { data } = await ContratoOriginacaoServiceSubEmpresa.confirmarVinculosRecebimentos(idLote, vinculosManuais);

                this.carregandoConfirmacaoVinculos = false;
                this.modalVinculoManualRecebimentosVisible = false;

                const aindaHaPendentes = (data || []).some(item => item.idTerritorio == null);

                if (!aindaHaPendentes) {
                    this.dadosLoteRecebimentos = {
                        ...this.dadosLoteRecebimentos,
                        statusCodigo: 'CONCLUIDO'
                    };
                    await this.abrirContratosEnLote(idLote);
                } else {
                    this.recebimentosPendentesVinculo = data || [];
                    this.modalVinculoManualRecebimentosVisible = true;
                };
            } catch {
                this.carregandoConfirmacaoVinculos = false;
                this.$notify.error({
                    message: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.erroConfirmarVinculos'
                    ),
                    position: 'top-right'
                });
            }
        },

        abrirModalSucessoProcessamento() {
            this.modalSucessoProcessamentoLoteVisible = true;
        },

        fecharModalSucessoProcessamento() {
            this.modalSucessoProcessamentoLoteVisible = false;
        },

        async confirmarContratosProcessados() {
            this.carregandoConfirmacaoContratos = true;

            await Promise.resolve();

            this.carregandoConfirmacaoContratos = false;
            this.modalSucessoProcessamentoLoteVisible = false;
            this.dadosLoteRecebimentos = {
                ...this.dadosLoteRecebimentos,
                statusCodigo: 'CONCLUIDO',
                status: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusConcluido'
                )
            };

            this.$notify.success({
                title: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.sucessoTitulo'
                ),
                message: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.vinculoManual.sucessoMensagem'
                ),
                position: 'top-right'
            });
        },

        notificarProcessamentoRecebimentosLoteIniciado() {
            this.$notify.info({
                title: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.processamentoTitulo'
                ),
                message: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.processamentoDetalhado'
                ),
                position: 'top-right',
                duration: 8000
            });
        },

        notificarStatusRecebimentosLote() {
            if (this.recebimentosAguardandoVinculo) return;

            const notifyType =
                this.statusRecebimentosTagType === 'danger'
                    ? 'error'
                    : 'success';

            this.$notify[notifyType]({
                message: `${this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.processamentoAtualizado'
                )} ${this.statusRecebimentosTexto}`,
                position: 'top-right'
            });
        },

        async handleWebSocketRecebimentosLote(mensagem) {
            try {
                const dados = typeof mensagem === 'string' ? JSON.parse(mensagem) : mensagem;
                this.dadosLoteRecebimentos = dados;

                if (dados.statusCodigo === 'AGUARDANDO_VINCULO' && dados.id) {
                    disconnect();
                    this.abrirVinculoManualParaLote(dados.id);
                } else {
                    this.notificarStatusRecebimentosLote();
                    if (['CONCLUIDO', 'PROCESSADO', 'ERRO_PROCESSAR', 'ERRO_AO_PROCESSAR'].includes(dados.statusCodigo)) {
                        disconnect();
                    }
                    if (dados.statusCodigo === 'CONCLUIDO' && dados.totalContratosAlocados > 0 && dados.id) {
                        await this.abrirContratosEnLote(dados.id);
                    } else if (dados.statusCodigo === 'CONCLUIDO' && dados.aviso) {
                        this.$notify.warning({
                            message: this.$t(`mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.${dados.aviso}`),
                            position: 'top-right'
                        });
                    }
                }
            } catch {
                // ignore parse errors
            }
        },

        async abrirContratosEnLote(idLote) {
            try {
                const { data } = await ContratoOriginacaoServiceSubEmpresa.buscarContratosEnLoteAR(idLote);
                if (!data || data.length === 0) {
                    const aviso = this.dadosLoteRecebimentos && this.dadosLoteRecebimentos.aviso;
                    const chave = aviso || 'semSaldoDisponivel';
                    this.$notify.warning({
                        message: this.$t(`mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.${chave}`),
                        position: 'top-right'
                    });
                    return;
                }
                this.contratosEnLote = data;
                this.modalContratosEnLoteVisible = true;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.erroBuscarContratosLote'),
                    position: 'top-right'
                });
            }
        },

        fecharModalContratosEnLote() {
            this.modalContratosEnLoteVisible = false;
        },

        editarContratoDoLote(contrato) {
            const territorio = contrato.territorios && contrato.territorios[0];
            this.modalContratosEnLoteVisible = false;
            this.$router.push({
                name: 'PreencherContratoOriginacao',
                params: { numeroContrato: contrato.numeroContrato },
                query: {
                    idTerritorio: territorio ? String(territorio.idTerritorio) : undefined,
                    idRepresentanteLote: territorio && territorio.idRepresentante ? String(territorio.idRepresentante) : undefined,
                    renspaTerritorio: territorio && territorio.renspa ? territorio.renspa : undefined,
                    volumeLote: territorio && territorio.volumeAlocado != null ? String(territorio.volumeAlocado).replace('.', ',') : undefined,
                    autoAnalise: 'true'
                }
            });
        },

        async confirmarProcessamentoEnLote() {
            this.carregandoConfirmacaoEnLote = true;
            try {
                const idLote = this.dadosLoteRecebimentos && this.dadosLoteRecebimentos.id;
                if (!idLote) throw new Error('ID do lote não encontrado.');

                await ContratoOriginacaoServiceSubEmpresa.confirmarProcessamentoEnLoteAR(idLote);

                this.modalContratosEnLoteVisible = false;
                this.$emit('atualizar');
                this.$notify.success({
                    message: this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.confirmacaoProcessamentoSucesso'),
                    position: 'top-right'
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.erroConfirmarProcessamento'),
                    position: 'top-right'
                });
            } finally {
                this.carregandoConfirmacaoEnLote = false;
            }
        }
    }
};
